import React from 'react';
import moment from 'moment';

export const cellRendererCheck = (value) => {
  if (!value) return '-';
  return value;
};

export const cellRendererNumber = (value) => {
  if (!value) return '0';
  return value;
};


export const cellRendererToolTip = (row) => {
  if (!row.faxStatus) return '-';
  return (<span title={row.faxStatusToolTip}>{row.faxStatus}</span>);
}

export const currencyFormat = (value) => {
  if (!value || isNaN(value)) return '$0.00';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-$' +
          (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {'$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};

export const decimalFormat = (value) => {
  if (!value || isNaN(value)) return '0.00';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-' + (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};

export const fileFormatter = (row, download) => {
  const { files } = row;
  if (files && files.length) {
    return files.map((file, index) => {
      return (
        <span
          className='fax-link'
          key={`${file.fileName}${index}`}
          onClick={() => download(file)}
        >
          {file.fileName}
          <br />
        </span>
      );
    });
  }
  return <span>There is no attachment</span>;
};

export const dateFormate = (value) => {
  if (!value) return '-';
  return moment(new Date(value)).format('MM/DD/YYYY');
};

export const dateOnly = (value) => {
  if (!value) return '-';
  let val = value;

  let regex = /^[a-zA-Z]/i;

  if (regex.test(val)) {
    return moment(new Date(val)).format('MM/DD/YYYY');
  }

  let hasTimePartZero = false;
  console.log(val);
  if (val.indexOf("T") == -1) {
    val = val + "T00:00:00";
    hasTimePartZero = true;
  }
  else if (val.indexOf("T00:00:00") != -1) {
    hasTimePartZero = true;
  }
  else if (val.indexOf("T") != -1) {
    let dtArr = val.split("T");
    val = dtArr[0] + "T00:00:00";
    hasTimePartZero = true;
  }
  if (hasTimePartZero) {
    return moment(new Date(val)).format('MM/DD/YYYY')
  }
  //return moment(new Date(value)).local().format('MM/DD/YYYY');
  return moment.utc(value).local().format('MM/DD/YYYY');
}

export const dateTimeFormate = (value) => {
  if (!value) return '-';

  var dt = moment(new Date(value)).format('MM/DD/YYYY hh:mm A');
  var strDt = new Date(dt+' UTC');
  return moment(new Date(strDt)).format('MM/DD/YYYY hh:mm A');
};

const userColumns = [
  {
    dataField: 'firstName',
    text: 'First Name',
    cellRenderer: (rowData) => cellRendererCheck(rowData.firstName),
    sort: true,
    width: 144,
    show: true,
    inputType: 'text',
  },
  {
    dataField: 'lastName',
    text: 'Last Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.lastName),
  },
  {
    dataField: 'userName',
    text: 'User Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.email),
  },
  {
    dataField: 'phoneNumber',
    text: 'Phone Number',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.phoneNumber),
  },
  {
    dataField: 'appAssigned',
    text: 'App. Assigned',
    sort: false,
    width: 130,
    show: true,
    edit: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (rowData) => cellRendererCheck(rowData.appAssigned),
  },
  {
    dataField: 'status',
    text: 'Status',
    sort: false,
    width: 150,
    show: true,
    edit: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (rowData) => cellRendererCheck(rowData.status),
  },
  {
    dataField: 'modifiedDate',
    text: 'Modified Date',
    sort: true,
    width: 90,
    show: true,
    inputType: 'date',
    cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
  },
  {
    dataField: 'modifiedBy',
    text: 'Modified By',
    sort: false,
    width: 90,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedBy),
  },
];

export default userColumns;